<template>
    <activation-brief-assets-provider v-slot="{
        brief,
        step,
        goNextStep,
        goPreviousStep,
        isLoading,
        isCompletingBrief,
    }" style="height: 100%">
        <activation-brief-assets-view
            :brief="brief"
            :step="step"
            :is-loading="isLoading"
            :is-completing-brief="isCompletingBrief"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
        />
    </activation-brief-assets-provider>
</template>
<script>
    import ActivationBriefAssetsView from "../data-views/activation-briefs/ActivationBriefAssetsView";
    import ActivationBriefAssetsProvider from "../providers/activation-brief-steps/ActivationBriefAssetsProvider";

    export default {
        name: "ActivationBriefAssetsRouterView",
        components: {
            ActivationBriefAssetsProvider,
            ActivationBriefAssetsView,
        }
    }
</script>
